import React, { useRef } from 'react';
import { staticImageAssets } from 'js/constants/Paths';

const MediaVideo = ({ item }) => {
  const { file_upload, video_poster = `${staticImageAssets('images/static/video_placeholder.png')}` } = item || {};
  const videoRef = useRef(null);

  return (
    <video
      playsInline
      controls
      preload="none"
      poster={video_poster}
      ref={videoRef}
      src={file_upload}
      type="video/mp4"
      controlsList="nodownload"
      onContextMenu={(e) => e.preventDefault()}
    />
  );
};

export default MediaVideo;
